export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/loader-re-cm.1ded46f4.gif";